import { blue } from '@material-ui/core/colors'
import { WithStyles, withStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import { SxProps, Typography } from '@mui/material'
import React, { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'

interface ICellLink extends PropsWithChildren<WithStyles> {
  disabled?: boolean
  sx?: SxProps
  tooltip?: boolean
  url: any
}

const CellLink = (props: ICellLink) => {
  const { url, children, classes, disabled = false, tooltip = false } = props
  if (tooltip) {
    return (
      <Typography variant="body1" title={children?.toString()} sx={props.sx}>
        <Link className={disabled ? classes.disabled : classes.root} to={url}>
          {children}
        </Link>
      </Typography>
    )
  }
  return (
    <Link className={disabled ? classes.disabled : classes.root} to={url}>
      {children}
    </Link>
  )
}

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      '&:hover': {
        color: blue[800],
      },
    },
    disabled: {
      cursor: 'not-allowed',
    },
  })

export default withStyles(styles)(CellLink)
